<form id="workhistory-information" [formGroup]="regForm" (ngSubmit)="step9Submitted(regForm)" novalidate>



  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;">{{'Step8-Work-History.TranslationSection.text1' | translate}}</label>
  
  </div><br><br>
  


  <div>

   
    <div class="form-row">
      <div class="form-group col-lg-6 col-md-6 col-sm-6" >

      <label >{{'Step8-Work-History.TranslationSection.text2' | translate}}<br>
        {{'Step8-Work-History.TranslationSection.text3' | translate}}
        </label>
      </div> 
  
    </div>


  <div class="form-row">
    <div class="form-group col-lg-6 col-md-6 col-sm-6" >
      <input class="form-check-inline" type="checkbox"  id="noemploy" formControlName="noemploy" value="Yes" (change)="noPriorClick($event.target.checked)">
      <div class="form-check-inline">
        <label class="form-check-label" for="yes"> {{'Step8-Work-History.TranslationSection.text4' | translate}}</label> 
      </div>   
    </div>
  </div>
  

<div class="form-row">
  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <label class="form-check-inline">{{'Step8-Work-History.TranslationSection.text5' | translate}}</label>
    <div class="form-check-inline">
        <textarea class="form-control"  id="noemployexp" for="noemployexp" formControlName="noemployexp" [ngClass]="{'form-submitted': isSubmitted}" ></textarea>
    </div>
  </div>
</div>


<div class="form-row" style="height:30px;"></div>
<!--
<div class="form-row">
  <div class="form-group col-lg-8 col-md-8 col-sm-8" >    
    <input class="form-check-inline" type="checkbox"  id="CO1AUTH" formControlName="CO1AUTH" value="Yes" >

    --was commented <input type="radio" formControlName="CO1AUTH" value='Yes'/>&nbsp;&nbsp;&nbsp;
    
    <div class="form-check-inline">
      <label class="form-check-label" for="yes"> I authorize this company information for reference check.
      </label> 
    </div>
  </div>
</div>
-->

<div class="form-row">
  <div class="form-group col-lg-3 col-md-3 col-sm-3  " >
      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text6' | translate}}
      </label> 
  </div>
  <div class="form-group col-lg-7 col-md-7 col-sm-7" >
    <input type="text" class="form-control" for="CO1NAME"  formControlName="CO1NAME" id="CO1NAME" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
  </div>
</div>

<div class="form-row">
  <div class="form-group col-lg-2 col-md-2 col-sm-2 " >

      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text7' | translate}}
      </label> 

  </div>

  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
  
    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text8' | translate}}
      </label> 
      <select id="CO1FROMMTH1" class="form-control" for="CO1FROMMTH1" formControlName="CO1FROMMTH1" [ngClass]="{'form-submitted': isSubmitted}">
   <!--<option [selected]="1==1">MONTH</option>--> 
        <option *ngFor="let month of months"  [ngValue]="month.value">{{month.name}}</option>
      </select>
    </div>  

    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text9' | translate}}
      </label> 
      <input type="text" class="form-control" for="CO1FROMYR"  formControlName="CO1FROMYR" id="CO1FROMYR" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>  


  </div>

</div>

<div class="form-row">
  <div class="form-group col-lg-2 col-md-2 col-sm-2  " >

      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text10' | translate}}
      </label> 

  </div>

  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
  
    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text11' | translate}}
      </label> 
      <select id="CO1TOMTH1" class="form-control" for="CO1TOMTH1" formControlName="CO1TOMTH1" [ngClass]="{'form-submitted': isSubmitted}">
            <!--<option [selected]="1==1">MONTH</option>--> 
        <option *ngFor="let month of months"  [ngValue]="month.value">{{month.name}}</option>
      </select>
    </div>  


    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text12' | translate}}
      </label> 
      <input type="text" class="form-control" for="CO1TOYR"  formControlName="CO1TOYR" id="CO1TOYR" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>  


  </div>

</div>

<div class="form-row">
  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <div class="form-check-inline">
      <label class="form-check-label" for="yes"> {{'Step8-Work-History.TranslationSection.text13' | translate}}
      </label> 
    </div>   
  </div>
</div>







<div class="form-row">

      <div class="form-group col-lg-5 col-md-5 col-sm-5 " >
          <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text14' | translate}}
          </label> 
          <input type="text" class="form-control" for="CO1ADD"  formControlName="CO1ADD" id="CO1ADD" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >     
      </div>

    <div class="form-group col-lg-5 col-md-5 col-sm-5  " >
        <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text15' | translate}}
        </label> 
        <input type="text" class="form-control" for="CO1ADD2"  formControlName="CO1ADD2" id="CO1ADD2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>

</div>

<div class="form-row">

  <div class="form-group col-lg-5 col-md-5 col-sm-5" >
      <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text16' | translate}}

      </label> 
      <input type="text" class="form-control" for="CO1POS"  formControlName="CO1POS" id="CO1POS" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >     
  </div>

<div class="form-group col-lg-6 col-md-6 col-sm-6  " >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text17' | translate}}
    </label> 
    <input type="text" class="form-control" for="SUPER"  formControlName="SUPER" id="SUPER" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
</div>




</div>

<div class="form-row">

  <div class="form-group col-lg-5 col-md-5 col-sm-5 " >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text18' | translate}}
    </label> 
    <input type="text" class="form-control" for="CO1PHONE"  formControlName="CO1PHONE" id="CO1PHONE" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000'>
  </div>

  
<div class="form-group col-lg-6 col-md-6 col-sm-6 " >
  <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text19' | translate}}
  </label> 
  <input type="text" class="form-check-inline" for="CO1EMAIL"  formControlName="CO1EMAIL" id="CO1EMAIL" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
</div>

</div>



<div class="form-row">

  <div class="form-group col-lg-6 col-md-6 col-sm-6 " >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text20' | translate}}
    </label> 
    <div class="form-check-inline">
      <textarea class="form-control"  id="CO1REASON" for="CO1REASON" formControlName="CO1REASON" ></textarea>
  </div>
  </div>
  


</div>



<div class="form-row" style="height:60px;"></div>

<div class="form-row">
  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <input class="form-check-inline" type="checkbox"  id="CO2AUTH" formControlName="CO2AUTH" value="Yes" >
    <!--<input type="radio" formControlName="CO2AUTH" value='Yes'/>&nbsp;&nbsp;&nbsp;-->

    <div class="form-check-inline">
      <label class="form-check-label" for="yes"> {{'Step8-Work-History.TranslationSection.text21' | translate}}
      </label> 
    </div>   
  </div>
</div>

<div class="form-row">
  <div class="form-group col-lg-3 col-md-3 col-sm-3  " >
      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text22' | translate}}
      </label> 
  </div>
  <div class="form-group col-lg-7 col-md-7 col-sm-7" >
    <input type="text" for="CO2NAME"  formControlName="CO2NAME" id="CO2NAME" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
  </div>
</div>

<div class="form-row">
  <div class="form-group col-lg-2 col-md-2 col-sm-2  " >

      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text23' | translate}}
      </label> 

  </div>

  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
  
    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text24' | translate}}
      </label> 
      <select id="CO1FROMMTH2" class="form-control" for="CO2FROMMTH2" formControlName="CO2FROMMTH2" [ngClass]="{'form-submitted': isSubmitted}">
            <!--<option [selected]="1==1">MONTH</option>--> 
        <option *ngFor="let month of months"  [ngValue]="month.value">{{month.name}}</option>
      </select>
    </div>  


    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text25' | translate}}
      </label> 
      <input type="text" class="form-check-inline" for="CO2FROMYR"  formControlName="CO2FROMYR" id="CO2FROMYR" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>  


  </div>

</div>

<div class="form-row">
  <div class="form-group col-lg-2 col-md-2 col-sm-2  " >

      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text26' | translate}}
      </label> 

  </div>

  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
  
    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text27' | translate}}
      </label> 
      <select id="CO2TOMTH2" class="form-control" for="CO2TOMTH2" formControlName="CO2TOMTH2" [ngClass]="{'form-submitted': isSubmitted}">
            <!--<option [selected]="1==1">MONTH</option>--> 
        <option *ngFor="let month of months"  [ngValue]="month.value">{{month.name}}</option>
      </select>
    </div>  


    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text28' | translate}}
      </label> 
      <input type="text" class="form-check-inline" for="CO2TOYR"  formControlName="CO2TOYR" id="CO2TOYR" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>  


  </div>

</div>

<div class="form-row">
  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <div class="form-check-inline">
      <label class="form-check-label" for="yes"> {{'Step8-Work-History.TranslationSection.text29' | translate}}
      </label> 
    </div>   
  </div>
</div>

<div class="form-row">

      <div class="form-group col-lg-5 col-md-5 col-sm-5 " >
          <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text30' | translate}}
          </label> 
          <input type="text" class="form-check-inline" for="CO2ADD"  formControlName="CO2ADD" id="CO2ADD" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >     
      </div>

    <div class="form-group col-lg-6 col-md-6 col-sm-6  " >
        <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text31' | translate}}
        </label> 
        <input type="text" class="form-check-inline" for="CO2ADD2"  formControlName="CO2ADD2" id="CO2ADD2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>

</div>

<div class="form-row">

  <div class="form-group col-lg-5 col-md-5 col-sm-5 t" >
      <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text32' | translate}}

      </label> 
      <input type="text" class="form-check-inline" for="CO2POS"  formControlName="CO2POS" id="CO2POS" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >     
  </div>

<div class="form-group col-lg-5 col-md-5 col-sm-5  " >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text33' | translate}}
    </label> 
    <input type="text" class="form-check-inline" for="SUPER2"  formControlName="SUPER2" id="SUPER2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
</div>



</div>

<div class="form-row">

  
<div class="form-group col-lg-5 col-md-5 col-sm-5  " >
  <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text34' | translate}}
  </label> 
  <input type="text" class="form-check-inline" for="CO2PHONE"  formControlName="CO2PHONE" id="CO2PHONE" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000'>
</div>



<div class="form-group col-lg-5 col-md-5 col-sm-5  " >
  <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text35' | translate}}
  </label> 
  <input type="text" class="form-check-inline" for="CO2EMAIL"  formControlName="CO2EMAIL" id="CO2EMAIL" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
</div>



</div>



<div class="form-row">

  <div class="form-group col-lg-6 col-md-6 col-sm-6  " >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text36' | translate}}
    </label> 
    <div class="form-check-inline">
      <textarea class="form-control"  id="CO2REASON" for="CO2REASON" formControlName="CO2REASON" ></textarea>
  </div>
  </div>
  
</div>



<div class="form-row" style="height:60px;"></div>

<div class="form-row">
  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <input class="form-check-inline" type="checkbox"  id="CO3AUTH" formControlName="CO3AUTH" value="Yes" >

    <!--<input type="radio" formControlName="CO3AUTH" value='Yes'/>&nbsp;&nbsp;&nbsp;-->


    <div class="form-check-inline">
      <label class="form-check-label" for="yes"> {{'Step8-Work-History.TranslationSection.text37' | translate}}
      </label> 
    </div>   
  </div>
</div>

<div class="form-row">
  <div class="form-group col-lg-3 col-md-3 col-sm-3  " >
      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text38' | translate}}
      </label> 
  </div>
  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <input type="text" for="CO3NAME"  formControlName="CO3NAME" id="CO3NAME" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
  </div>
</div>

<div class="form-row">
  <div class="form-group col-lg-2 col-md-2 col-sm-2  " >

      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text39' | translate}}
      </label> 

  </div>

  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
  
    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text40' | translate}}
      </label> 
      <select id="CO3FROMMTH3" class="form-control" for="CO3FROMMTH3" formControlName="CO3FROMMTH3" [ngClass]="{'form-submitted': isSubmitted}">
            <!--<option [selected]="1==1">MONTH</option>--> 
        <option *ngFor="let month of months"  [ngValue]="month.value">{{month.name}}</option>
      </select>
    </div>  


    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text41' | translate}}
      </label> 
      <input type="text" class="form-check-inline" for="CO3FROMYR"  formControlName="CO3FROMYR" id="CO3FROMYR" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>  


  </div>

</div>

<div class="form-row">
  <div class="form-group col-lg-2 col-md-2 col-sm-2  " >

      <label class="form-check-label" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text42' | translate}}
      </label> 

  </div>

  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
  
    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text43' | translate}}
      </label> 
      <select id="CO3TOMTH3" class="form-control" for="CO3TOMTH3" formControlName="CO3TOMTH3" [ngClass]="{'form-submitted': isSubmitted}">
           <!--<option [selected]="1==1">MONTH</option>--> 
        <option *ngFor="let month of months"  [ngValue]="month.value">{{month.name}}</option>
      </select>
    </div>  


    <div class="form-check-inline">
      <label class="form-check-inline" for="yes"> {{'Step8-Work-History.TranslationSection.text44' | translate}}
      </label> 
      <input type="text" class="form-check-inline" for="CO3TOYR"  formControlName="CO3TOYR" id="CO3TOYR" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>  


  </div>

</div>

<div class="form-row">
  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <div class="form-check-inline">
      <label class="form-check-label" for="yes"> {{'Step8-Work-History.TranslationSection.text45' | translate}}
      </label> 
    </div>   
  </div>
</div>

<div class="form-row">

      <div class="form-group col-lg-5 col-md-5 col-sm-5" >
          <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text46' | translate}}
          </label> 
          <input type="text" class="form-check-inline" for="CO3ADD"  formControlName="CO3ADD" id="CO3ADD" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >     
      </div>

    <div class="form-group col-lg-5 col-md-5 col-sm-5" >
        <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text47' | translate}}
        </label> 
        <input type="text" class="form-check-inline" for="CO3ADD2"  formControlName="CO3ADD2" id="CO3ADD2" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    </div>

</div>

<div class="form-row">

  <div class="form-group col-lg-5 col-md-5 col-sm-5" >
      <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text48' | translate}}

      </label> 
      <input type="text" class="form-check-inline" for="CO3POS"  formControlName="CO3POS" id="CO3POS" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >     
  </div>

<div class="form-group col-lg-5 col-md-5 col-sm-5" >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text49' | translate}}
    </label> 
    <input type="text" class="form-check-inline" for="SUPER3"  formControlName="SUPER3" id="SUPER3" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
</div>




</div>

<div class="form-row">

  <div class="form-group col-lg-5 col-md-5 col-sm-5" >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text50' | translate}}
    </label> 
    <input type="text" class="form-check-inline" for="CO3PHONE"  formControlName="CO3PHONE" id="CO3PHONE" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" mask='(000) 000-0000'>
  </div>
  


<div class="form-group col-lg-5 col-md-5 col-sm-5" >
  <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text51' | translate}}
  </label> 
  <input type="text" class="form-check-inline" for="CO3EMAIL"  formControlName="CO3EMAIL" id="CO3EMAIL" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
</div>


</div>


<div class="form-row" >


  <div class="form-group col-lg-6 col-md-6 col-sm-6" >
    <label class="form-check-inline" for="yes" style="font-weight:bold;"> {{'Step8-Work-History.TranslationSection.text52' | translate}}
    </label> 
    <div class="form-check-inline">
      <textarea class="form-control"  id="CO3REASON" for="CO3REASON" formControlName="CO3REASON" ></textarea>
  </div>
  </div>
  


</div>


<div class="form-row" style="height:30px;"></div>

<div class="form-row">
  <div class="form-group col-lg-10 col-md-10 col-sm-10" >
    <input class="form-check-inline" type="checkbox"  id="WHAR" formControlName="WHAR"  [checked]=false>


   <!-- <input type="radio" formControlName="WHAR" value='Yes'/>&nbsp;&nbsp;&nbsp;-->

    <div class="form-check-inline">
      <label class="form-check-label" for="yes"> {{'Step8-Work-History.TranslationSection.text53' | translate}}
      </label> 
    </div>   
  </div>
</div>



</div>


<br/>

<button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step8-Work-History.TranslationSection.text54' | translate}}</button>
&nbsp;
<button type="submit"  class="btn btn-primary" >{{'Step8-Work-History.TranslationSection.text55' | translate}} &nbsp;
<i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   

<div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step8-Work-History.TranslationSection.text56' | translate}}</i>

</form>